<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { TabsTrigger, type TabsTriggerProps, useForwardProps } from "radix-vue"
import { useClass } from "~/composables/local/cn-class"

const { class: rawClass, ...props } = defineProps<TabsTriggerProps & { class?: HTMLAttributes["class"] }>()

const forwardedProps = useForwardProps(() => props)

const className = useClass(
	"inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow",
	() => rawClass,
)
</script>

<template>
	<TabsTrigger
		v-bind="forwardedProps"
		:class="className">
		<slot />
	</TabsTrigger>
</template>
